import React, { Component } from "react";

import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import ApplicationList from "../../../components/ApplicationList/ApplicationList";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class NonCohortReport extends Component {
  render() {
    return (
      <>
        <React.Fragment>
          <div className="page-content">
          <ModifiedMetaTags title="Quality non cohort report | Mobihunter" />

            <Container fluid>
              <Breadcrumbs
                title="Dashboard"
                breadcrumbItem="Quality non cohort report"
                link="/quality-report"
              />

              <ApplicationList
                pathname="quality-report"
                history={this.props.history}
              />
            </Container>
          </div>
        </React.Fragment>
      </>
    );
  }
}

NonCohortReport.propTypes = {
  history: PropTypes.any,
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, null)(NonCohortReport);
